<template>
  <div
    class="form-group column"
    :class="[
    {'input-group': hasIcon},
    {'has-danger mb-4': error},
    {'focused': focused},
    {'has-label': label || $slots.label},
    {'has-success': valid === true},
    {'has-danger': valid === false}
    ]"
  >
    <slot name="label">
      <label v-if="label" class="form-control-label" :class="labelClasses">
        {{label}}
        <span v-if="required">*</span>
      </label>
    </slot>

    <div v-if="addonLeftIcon || $slots.addonLeft" class="input-group-prepend">
      <span class="input-group-text">
        <slot name="addonLeft">
          <i :class="addonLeftIcon"></i>
        </slot>
      </span>
    </div>
    <slot v-bind="slotData">
      <editor-menu-bar :editor="txtEditor" v-slot="{ commands, isActive }">
        <div class="comandos d-flex flex-row">
          <div
            :class="{ 'active': isActive.bold() }"
            @click="commands.bold()"
            class="btnEditor d-flex flex-column clickable align-content-center justify-content-center"
          >
            <span class="fas fa-bold"></span>
          </div>

          <div
            :class="{ 'active': isActive.italic() }"
            @click="commands.italic()"
            class="btnEditor d-flex flex-column clickable align-content-center justify-content-center"
          >
            <span class="fas fa-italic"></span>
          </div>

          <div
            :class="{ 'active': isActive.underline() }"
            @click="commands.underline()"
            class="btnEditor d-flex flex-column clickable align-content-center justify-content-center"
          >
            <span class="fas fa-underline"></span>
          </div>

          <div
            :class="{ 'active': isActive.strike() }"
            @click="commands.strike()"
            class="btnEditor d-flex flex-column clickable align-content-center justify-content-center"
          >
            <span class="fas fa-strikethrough"></span>
          </div>

          <div
            :class="{ 'active': isActive.link() }"
            @click="modalLink"
            class="btnEditor ml-3 d-flex flex-column clickable align-content-center justify-content-center"
          >
            <span class="fas fa-link"></span>
          </div>
        </div>
      </editor-menu-bar>
      <div><editor-content
        v-on="listeners"
        :editor="txtEditor"
        class="textEditor form-control"
        :class="[inputClasses,{focused:focused}]"
        v-model="valueCorrigido"
      /></div>
    </slot>
    <div v-if="addonRightIcon || $slots.addonRight" class="input-group-append">
      <span class="input-group-text">
        <slot name="addonRight">
          <i :class="addonRightIcon"></i>
        </slot>
      </span>
    </div>
    <slot name="infoBlock"></slot>
    <slot name="helpBlock">
      <div
        class="text-danger invalid-feedback"
        style="display: block;"
        :class="{'mt-2': hasIcon}"
        v-if="error"
      >{{ error }}</div>
    </slot>

    <modal
      :show.sync="modal.link.aberto"
      class="liveEditor"
      type="notice"
      modalContentClasses="bg-default text-white"
      :showClose="false"
    >
      <template slot="header">
        <h5 class="modal-title text-white" id="exampleModalLabel">Inserir link</h5>
      </template>
      <div class="row justify-content-between pl-3 pr-3">
        <base-input
          v-model="modal.link.url"
          placeholder="Ex: www.liveoficial.com.br"
          type="url"
          inputClasses="grow bg-white text-default form-control-alternative"
          label="Informe a URL"
        ></base-input>
        <base-input label="Onde abrir?">
          <base-dropdown class="d-flex" direction="up">
            <!-- botão -->
            <base-button slot="title" type="white" class="dropdown-toggle col-12">Selecione...</base-button>
            <!-- opções -->
            <a
              class="dropdown-item"
              href="#"
              @click="modal.link.target = o.val"
              :key="'opc_'+oi"
              v-for="(o,oi) in modal.link.opcoesTarget"
            >{{o.nome}}</a>
          </base-dropdown>
        </base-input>
      </div>
      <template slot="footer">
        <base-button type="secondary" size="sm" @click="modal.link.aberto=false">Cancelar</base-button>
        <base-button type="success" @click="inserirLink" size="sm">Inserir</base-button>
      </template>
    </modal>
  </div>
</template>
<script>
import { Editor, EditorContent, EditorMenuBar } from "tiptap";
import {
  Blockquote,
  CodeBlock,
  HardBreak,
  Heading,
  HorizontalRule,
  OrderedList,
  BulletList,
  ListItem,
  TodoItem,
  TodoList,
  Bold,
  Code,
  Italic,
  Link,
  Strike,
  Underline,
  History,
} from "tiptap-extensions";

export default {
  components: {
    EditorContent,
    EditorMenuBar,
  },
  name: "text-editor",
  props: {
    required: {
      type: Boolean,
      description: "Este campo é obrigatório? (adds an asterix *)",
    },
    valid: {
      type: Boolean,
      description: "É valido?",
      default: undefined,
    },
    label: {
      type: String,
      description: "Label do input (texto antes)",
    },
    error: {
      type: String,
      description: "Erro do input (texto depois)",
    },
    labelClasses: {
      type: String,
      description: "classes do label",
    },
    inputClasses: {
      type: String,
      description: "Classes do input",
    },
    value: {
      type: [String, Number],
      description: "Valor do input",
    },
    addonRightIcon: {
      type: String,
      description: "Addon right icon",
    },
    addonLeftIcon: {
      type: String,
      description: "Addont left icon",
    },
  },
  computed: {
    listeners() {
      return {
        ...this.$listeners,
        input: this.updateValue,
        focus: this.onFocus,
        blur: this.onBlur,
      };
    },
    slotData() {
      return {
        focused: this.focused,
        ...this.listeners,
      };
    },
    hasIcon() {
      const { addonRight, addonLeft } = this.$slots;
      return (
        addonRight !== undefined ||
        addonLeft !== undefined ||
        this.addonRightIcon !== undefined ||
        this.addonLeftIcon !== undefined
      );
    },
    valueCorrigido() {
      if (this.txtEditor && this.value != this.txtEditor.getHTML())
        this.txtEditor.setContent(this.value);
      return this.value;
    },
  },
  methods: {
    teste() {
      alert("teste");
    },
    modalLink() {
      this.modal.link.aberto = true;
      this.modal.link.url = "";
      this.modal.link.texto = "";
      this.modal.link.target = "_self";
    },
    inserirLink() {
      this.txtEditor.link({ href: "teste" });
    },
    updateValue() {
      let value = this.txtEditor.getHTML();
      this.$emit("input", value);
    },
    onFocus(value) {
      this.focused = true;
      this.$emit("focus", value);
    },
    onBlur(value) {
      this.focused = false;
      this.$emit("blur", value);
    },
  },
  data() {
    return {
      focused: false,
      txtEditor: null,
      modal: {
        link: {
          aberto: false,
          url: "",
          texto: "",
          target: "_self",
          opcoesTarget: [
            { val: "_blank", nome: "Nova página" },
            { val: "_self", nome: "Mesma página" },
          ],
        },
      },
    };
  },
  mounted() {
    var app = this;
    this.txtEditor = new Editor({
      content: app.value,
      extensions: [
        new Blockquote(),
        new BulletList(),
        new CodeBlock(),
        new HardBreak(),
        new Heading({ levels: [1, 2, 3] }),
        new HorizontalRule(),
        new ListItem(),
        new OrderedList(),
        new TodoItem(),
        new TodoList(),
        new Link(),
        new Bold(),
        new Code(),
        new Italic(),
        new Strike(),
        new Underline(),
        new History(),
      ],
      onUpdate: () => {
        // get new content on update
        app.updateValue();
      },
      onFocus: () => {
        app.onFocus();
      },
      onBlur: () => {
        app.onBlur();
      },
    });
  },
  beforeDestroy() {
    this.txtEditor.destroy();
  },
};
</script>
<style>
.comandos {
  margin-bottom: 5px;
}
.textEditor {
  height: auto;
}
.btnEditor {
  border-radius: 3px;
  min-width: 30px;
  padding: 0 5px;
  height: 30px;
  margin-right: 2px;
  margin-bottom: 2px;
  text-transform: uppercase;
  text-align: center;
  font-size: 12px;
  color: #333;
  background: rgba(0, 0, 0, 0.15);
  transition: 0.2s;
}
.btnEditor:hover {
  background: rgba(0, 0, 0, 0.35);
}
.btnEditor.active {
  background: rgba(0, 0, 0, 0.85);
  color: #fff;
}
.ProseMirror-focused {
  outline: none;
}
</style>